import { LazyLoader, Modal } from '@bp/ui-components';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CurriculumBlockContainerForm } from '../Forms/CurriculumBlockContainerForm';

type CurriculumBlockContainerModalProps = {
  versionUuid: string | null;
  curriculumUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const CurriculumBlockContainerModal = ({
  versionUuid,
  curriculumUuid,
  isOpen,
  onClose,
}: CurriculumBlockContainerModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={loading}
      isOpen={isOpen}
      onRequestClose={onClose}
      title={curriculumUuid ? t('epochs.editPlan') : t('epochs.addPlan')}
    >
      <Suspense fallback={<LazyLoader embedded forceHeight='40vh' />}>
        <CurriculumBlockContainerForm
          curriculumUuid={curriculumUuid}
          versionUuid={versionUuid}
          defaultInitialValues={{ curriculumVersionUuid: versionUuid ?? '', timetableEnabled: true }}
          onLoad={setLoading}
          onClose={onClose}
        />
      </Suspense>
    </Modal>
  );
};
